import { Spinner } from '@frontend/authorization';
import { ObjectSelectInputV2, ObjectSelectV2Props } from '@frontend/form';
import { IoTClient } from '@frontend/iot/api';
import { IoT, IoTQueryParams } from '@frontend/iot/types';
import { useAccountRepository } from '@frontend/repository';
import React, { useState } from 'react';

const ID = 'iot-select';
export interface IoTSelectProps extends ObjectSelectV2Props<IoT, IoTQueryParams> {}
/**
 * @deprecated
 */
export const IoTSelect = (props: IoTSelectProps) => {
    const {
        store: { currentAccount }
    } = useAccountRepository();
    const [v, cV] = useState<IoT | null>(null);

    if (!currentAccount) return <Spinner />;
    return (
        <ObjectSelectInputV2<IoT, IoTQueryParams>
            {...props}
            id={`${ID}${props.id && '-' + props.id}`}
            label={props.label || 'IoT'}
            className={props.className}
            onChange={(v) => {
                props.onChange && props.onChange(v?.id || null);
                props.onChangeObject && props.onChangeObject(v);
                cV(v);
            }}
            isClearable={props.isClearable}
            required={props.required}
            queryParams={props.queryParams}
            value={v}
            idValue={props.value || v?.id}
            fetch={(arg) => IoTClient.fetchIoTs({ ...arg, sort_field: 'name', sort_direction: 'asc' })}
            itemLabel={(iot) => iot.name}
            useQueryParam={
                props.allowURLChange
                    ? {
                          param: 'iot',
                          fetch: (pathParam) => IoTClient.fetchIoT(currentAccount!, pathParam)
                      }
                    : undefined
            }
            hideOnOneOption={props.hideOnOneOption}
            helpMessage={props.helpMessage}
        />
    );
};
